export enum BookingsEndpoints {
    getMyBookings = '/v1/bookings',
    getBookingsSummary = '/v1/bookings/summary',
    patchMyBookings = '/v1/bookings/{id}',
    getInspections = '/v1/bookings/inspections',
    postInspectionAction = '/v1/bookings/inspections/:inspectionId/actions',
    patchInspection = '/v1/bookings/inspections/:inspectionId',
    getVoucherCode = '/v1/bookings/voucher',
}

export enum BookingStatus {
    Past = 'PAST',
    Upcoming = 'UPCOMING',
    Current = 'CURRENT',
}
